import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-4" }
const _hoisted_2 = { class: "crm:grid crm:grid-cols-1 crm:lg:grid-cols-3 crm:gap-1 crm:p-4 crm:lg:p-4" }
const _hoisted_3 = { class: "crm:w-full" }
const _hoisted_4 = { class: "crm:w-full" }
const _hoisted_5 = { class: "crm:w-full" }
const _hoisted_6 = { class: "crm:inline-block crm:text-center crm:w-full" }

import { ref, inject, reactive } from 'vue'
import ThePageLayout from '../ThePageLayout.vue'
import BaseTableBackend from '../../components/BaseTableBackend.vue'
import BaseTableBackendFilter from '../../components/BaseTableBackend/BaseTableBackendFilter.vue'
import BaseTableBackendPagination from '../../components/BaseTableBackend/BaseTableBackendPagination.vue'


export default {
  __name: 'RubricaSoggetti',
  props: {
  /**
   * dati utente connesso
   */
  dati: {
    type: [Object, Array],
    default() {
      return {}
    }
  }
},
  setup(__props) {

/**
 * @doc renderizza la lista dei soggetti anagraficati nelle pratiche.
 */
const props = __props

const rubricaSoggetti = reactive({
  soggetti       : [],
  soggettiDefault: [],
  totalItems     : 0,
  colonne        : {
    nome_completo     : { name: 'Nome Completo', size: '20%', sortable: true, sortable_map: 'cognome' },
    tipologia_soggetto: { name: 'Tipologia', size: '10%' },
    cf_piva           : { name: 'C.F. / P.IVA', size: '10%' },
    telefono          : { name: 'Telefono', size: '10%' },
    email             : { name: 'Email', size: '15%' },
    sogg_rappresentato: { name: 'Soggetto Rappresentato', size: '15%' },
    pratiche          : { name: 'Pratiche', size: '5%', align: 'center' }
  }
})

/**
 * Al click su un soggetto viene fatto un redirect al suo dettaglio
 * @param soggetto
 */
function redirectADettaglioRubricaSoggetti(soggetto) {
  location.href = window.location.protocol + '//' + window.location.hostname + '/rubrica_soggetto?soggetto_id=' + soggetto.soggetto_id
}

/**
 * @inject {$L_} shortcut per accedere ai metodi di lodash messi a disposizione nel base_instance
 */
const $L_ = inject('$L_')


const filtriSoggetti = ref({
  soggetto   : { value: '' },
  cod_fiscale: { value: '' },
  email      : { value: '' },
  live_filter: true
})

const filtriSoggettiDefault = ref($L_.cloneDeep(filtriSoggetti.value))

/**
 * Aggiorna il numero totale di elementi della tabella restiuiti dal backend
 * @param value
 */
function updateTotalItems(value) {
  rubricaSoggetti.totalItems = value
}

return (_ctx, _cache) => {
  const _component_base_input_text = _resolveComponent("base-input-text")

  return (_openBlock(), _createBlock(ThePageLayout, {
    dati: __props.dati,
    intestazione: {currentPage: 'rubrica_soggetti', title: `Rubrica Soggetti <small>(${rubricaSoggetti.totalItems})</small>`}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseTableBackend, {
          dati: rubricaSoggetti.soggetti,
          "onUpdate:dati": _cache[4] || (_cache[4] = $event => ((rubricaSoggetti.soggetti) = $event)),
          "dati-default": rubricaSoggetti.soggettiDefault,
          "onUpdate:datiDefault": _cache[5] || (_cache[5] = $event => ((rubricaSoggetti.soggettiDefault) = $event)),
          columns: rubricaSoggetti.colonne,
          "is-row-clickable": true,
          onUpdate_totalItems: updateTotalItems,
          onOnClickRow: redirectADettaglioRubricaSoggetti,
          "empty-message": "Non sono presenti soggeti nella rubrica",
          "http-params": {controller: 'Rubrica_soggetti', action:'getSoggetti', path: 'rubrica_soggetti'},
          id: "tableRubrica"
        }, {
          content: _withCtx(() => [
            _createVNode(BaseTableBackendFilter, {
              "filters-default": filtriSoggettiDefault.value,
              filters: filtriSoggetti.value,
              "onUpdate:filters": _cache[3] || (_cache[3] = $event => ((filtriSoggetti).value = $event)),
              "custom-classes": {toggleBar: {base: {value: 'bg-transparent', condition: true}}, switchSlider: {base: {value: 'bg-black', condition: true}}}
            }, {
              filters: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "crm:w-full crm:block" }, " Nome completo ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_base_input_text, {
                        name: "filter_soggetto",
                        class: "crm:rounded-br-none crm:rounded-tr-none",
                        validateTo: filtriSoggetti.value.soggetto,
                        "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((filtriSoggetti.value.soggetto) = $event))
                      }, null, 8 /* PROPS */, ["validateTo"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "crm:w-full crm:block" }, " C.F. / P.Iva ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_base_input_text, {
                        class: "crm:rounded-br-none crm:rounded-tr-none",
                        name: "filter_cod_fiscale",
                        validateTo: filtriSoggetti.value.cod_fiscale,
                        "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((filtriSoggetti.value.cod_fiscale) = $event))
                      }, null, 8 /* PROPS */, ["validateTo"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "crm:w-full crm:block" }, " Email ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_base_input_text, {
                        class: "crm:rounded-bl-none crm:rounded-tl-none",
                        name: "filter_email",
                        validateTo: filtriSoggetti.value.email,
                        "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((filtriSoggetti.value.email) = $event))
                      }, null, 8 /* PROPS */, ["validateTo"])
                    ])
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filters-default", "filters"])
          ]),
          nome_completo: _withCtx(({elemento}) => [
            _createTextVNode(_toDisplayString(elemento.ragione_sociale ? elemento.ragione_sociale : elemento.cognome + ' ' + elemento.nome), 1 /* TEXT */)
          ]),
          tipologia_soggetto: _withCtx(({elemento}) => [
            _createTextVNode(_toDisplayString(elemento.tipologia_soggetto === 'PG' ? 'Persona giuridica' : 'Persona fisica'), 1 /* TEXT */)
          ]),
          cf_piva: _withCtx(({elemento}) => [
            _createTextVNode(_toDisplayString(!elemento.cod_fiscale && !elemento.partita_iva ? '-' : `${elemento.cod_fiscale || ''}${elemento.cod_fiscale && elemento.partita_iva ? ' / ' : ''}${elemento.partita_iva || ''}`), 1 /* TEXT */)
          ]),
          pratiche: _withCtx(({elemento}) => [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(elemento.numero_pratiche !== null ? elemento.numero_pratiche : 1), 1 /* TEXT */)
            ])
          ]),
          pagination: _withCtx(() => [
            _createVNode(BaseTableBackendPagination)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["dati", "dati-default", "columns"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["dati", "intestazione"]))
}
}

}